// Contact Form 7 送信時にローディング（クルクル）を表示
// SCSS の .loading-wrapper.is-visible { display: block !important } で表示
document.addEventListener('DOMContentLoaded', function() {
  var wrapper = document.getElementById('loading-wrapper');
  if (!wrapper) return;

  function showLoading() {
    wrapper.classList.add('is-visible');
    wrapper.setAttribute('aria-hidden', 'false');
  }

  function hideLoading() {
    wrapper.classList.remove('is-visible');
    wrapper.setAttribute('aria-hidden', 'true');
  }

  // 送信ボタン押下で表示（フォーム submit 時）
  var form = document.querySelector('.wpcf7 form');
  if (form) {
    form.addEventListener('submit', function() {
      showLoading();
    });
  }

  // CF7 イベントで非表示
  document.addEventListener('wpcf7submitting', showLoading);
  // 送信成功: ローディングを消して完了ページへリダイレクト
  document.addEventListener('wpcf7mailsent', function() {
    hideLoading();
    window.location.href = '/consult/complete/';
  });
  document.addEventListener('wpcf7mailfailed', hideLoading);
  document.addEventListener('wpcf7invalid', hideLoading);
});
